import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-x-clone",
  "use": "app-icon-x-clone-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"app-icon-x-clone\"><path d=\"M21.5 3H8v4.5H3.5V21H17v-4.5h4.5V3zm-6.187 16.313H5.187V9.187h2.814V16.5h7.312v2.813zm0-4.5H9.687V9.187h5.626v5.626zm4.5 0H17.28V7.219H9.687V4.687h10.126v10.126z\" fill=\"#6C7280\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol